/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import produce from 'immer';
import {reInitializeState} from '@ion/applications/src/helpers';
import {
  AdminMaintenanceTab,
  RE_INITIALIZE_ADMIN_MAINTENANCE,
  SET_SELECTED_ADMIN_MAINTENANCE_TAB,
  SetSelectedTabAction
} from '../actions/admin-maintenance';

export interface AdminMaintenanceState {
  selectedTab: AdminMaintenanceTab
}

// defines the initial state for the reducer ...
export const initialState: AdminMaintenanceState = {
  selectedTab : AdminMaintenanceTab.SCHEDULES
};

// defines this reducers reducer functions ...
const reducers = {
  [SET_SELECTED_ADMIN_MAINTENANCE_TAB] : (
    draft: AdminMaintenanceState, {selectedTab}: SetSelectedTabAction) => {
    draft.selectedTab = selectedTab;
  },
  [RE_INITIALIZE_ADMIN_MAINTENANCE] : (draft) => {
    reInitializeState(draft, {initialState});
  }
};

/**
 * defines all reducers for actions of interest to the this reducer ...
 */
export default produce((draft: AdminMaintenanceState = initialState, action) => {
  reducers?.[action.type]?.(draft, action);
  return draft;
});
